var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.63 0.630024C0.24 1.02002 0.24 1.65002 0.63 2.04002L4.29 5.70002L4 6.00002H1C0.45 6.00002 0 6.45002 0 7.00002V11C0 11.55 0.45 12 1 12H4L7.29 15.29C7.92 15.92 9 15.47 9 14.58V10.41L13.18 14.59C12.69 14.96 12.16 15.27 11.58 15.5C11.22 15.65 11 16.03 11 16.42C11 17.14 11.73 17.6 12.39 17.33C13.19 17 13.94 16.56 14.61 16.02L15.95 17.36C16.34 17.75 16.97 17.75 17.36 17.36C17.75 16.97 17.75 16.34 17.36 15.95L2.05 0.630024C1.66 0.240024 1.03 0.240024 0.63 0.630024ZM16 9.00002C16 9.82002 15.85 10.61 15.59 11.34L17.12 12.87C17.68 11.7 18 10.39 18 9.00002C18 5.17002 15.6 1.89002 12.22 0.600024C11.63 0.370024 11 0.830024 11 1.46002V1.65002C11 2.03002 11.25 2.36002 11.61 2.50002C14.18 3.54002 16 6.06002 16 9.00002ZM7.29 2.71002L7.12 2.88002L9 4.76002V3.41002C9 2.52002 7.92 2.08002 7.29 2.71002ZM13.5 9.00002C13.5 7.23002 12.48 5.71002 11 4.97002V6.76002L13.48 9.24002C13.49 9.16002 13.5 9.08002 13.5 9.00002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOff);
export default __webpack_public_path__ + "static/media/volume_off.593793edc8aafe1483a5141bc6579328.svg";
export { ForwardRef as ReactComponent };